<template>
	<b-table-simple
		id="tabel-dinamis-pivot-table"
		:table-class="
			fontSizeClass +
			' ' +
			(isStripped ? strippedTableClass : '') +
			' ' +
			(isHighlighted ? hoveredTableClass : '')
		"
		responsive
		small
		bordered
		:hover="isHighlighted"
		:striped="isStripped"
		caption-top
		:no-border-collapse="isFreeze"
		:sticky-header="isFreeze"
		v-if="theadArr.length > -1 && tbodyArr.length > -1"
	>
		<b-thead
			:style="{
				position: isFreeze ? 'sticky' : '',
				top: isFreeze ? '0' : '',
				'z-index': isFreeze ? '3' : '',
			}"
		>
			<b-tr v-for="(theadRow, indexTheadRow) in theadArr" :key="indexTheadRow">
				<template v-for="(thead, indexThead) in theadRow">
					<b-th
						v-if="thead.text === ''"
						:colspan="thead.colspan"
						:key="indexThead"
						:sticky-column="isFreeze"
						:style="{ border: 'hidden', left: thead.left + 'px' }"
					>
					</b-th>

					<template v-else>
						<template
							v-if="typeof thead.colspan === 'number' && thead.colspan <= 1000"
						>
							<b-th
								:class="thBgClass + ' tabel-dinamis-th'"
								:colspan="thead.colspan"
								:key="indexThead"
							>
								{{ thead.text }}
							</b-th>
						</template>

						<template v-else-if="typeof thead.colspan === 'object'">
							<b-th
								:class="
									thBgClass +
									' tabel-dinamis-th ' +
									thBorderRightClass +
									' ' +
									(idx !== 0 ? thBorderLeftClass : '')
								"
								v-for="(item, idx) in thead.colspan.left"
								:colspan="item"
								:key="indexThead + '-left-' + idx"
							>
							</b-th>

							<b-th
								:class="
									thBgClass +
									' tabel-dinamis-th ' +
									thBorderLeftClass +
									' ' +
									thBorderRightClass
								"
								:colspan="thead.colspan.mid"
								:key="indexThead + '-mid'"
							>
								{{ thead.text }}
							</b-th>

							<b-th
								:class="
									thBgClass +
									' tabel-dinamis-th ' +
									thBorderLeftClass +
									' ' +
									(idx !== arrayLength(thead.colspan.right) - 1
										? thBorderRightClass
										: '')
								"
								v-for="(item, idx) in thead.colspan.right"
								:colspan="item"
								:key="indexThead + '-right-' + idx"
							>
							</b-th>
						</template>
					</template>
				</template>

				<template v-if="choosenColumnFieldsLength > 0 && indexTheadRow === 0">
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doSum"
					>
						Sum
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doAverage"
					>
						Average
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doMinimum"
					>
						Minimum
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doMaximum"
					>
						Maximum
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doMedian"
					>
						Median
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doCount"
					>
						Count
					</b-th>
					<b-th
						:class="thTextClass + ' tabel-dinamis-columns-summary-th'"
						:rowspan="choosenColumnFieldsLength"
						v-show="doStandardDeviation"
					>
						Standard Deviation
					</b-th>
				</template>
			</b-tr>
		</b-thead>

		<b-tbody>
			<b-tr v-for="(tbodyRow, indexTbodyRow) in tbodyArr" :key="indexTbodyRow">
				<template v-for="(tbodyCol, indexTbodyCol) in tbodyRow">
					<b-th
						:class="thBgClass + ' tabel-dinamis-th'"
						v-if="tbodyCol.type === 'th'"
						:rowspan="tbodyCol.rowspan"
						:key="indexTbodyCol"
						:sticky-column="isFreeze"
						:style="{ left: isFreeze ? tbodyCol.left + 'px' : '' }"
					>
						{{ tbodyCol.value }}
					</b-th>

					<b-td
						:class="
							'tabel-dinamis-td py-2 ' +
							checkTdAsMinimumX(tbodyCol.value, indexTbodyRow) +
							checkTdAsMaximumX(tbodyCol.value, indexTbodyRow) +
							checkTdAsMinimumY(tbodyCol.value, indexTbodyCol) +
							checkTdAsMaximumY(tbodyCol.value, indexTbodyCol)
						"
						v-else-if="tbodyCol.type === 'td'"
						:key="indexTbodyCol"
					>
						{{ tbodyCol.value }}
					</b-td>
				</template>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doSum"
				>
					{{ formatNumber(pivotDataSumRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doAverage"
				>
					{{ formatNumber(pivotDataAverageRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doMinimum"
				>
					{{ formatNumber(pivotDataMinimumRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doMaximum"
				>
					{{ formatNumber(pivotDataMaximumRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doMedian"
				>
					{{ formatNumber(pivotDataMedianRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doCount"
				>
					{{ formatNumber(pivotDataCountRows[indexTbodyRow]) }}
				</b-td>

				<b-td
					class="tabel-dinamis-columns-summary-td"
					v-if="choosenColumnFieldsLength > 0 && doStandardDeviation"
				>
					{{ formatNumber(pivotDataStandardDeviationRows[indexTbodyRow]) }}
				</b-td>
			</b-tr>
		</b-tbody>

		<b-tfoot v-show="choosenRowFieldsLength > 0">
			<b-tr v-show="doSum">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Sum
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataSumCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doAverage">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Average
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataAverageCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doMinimum">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Minimum
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataMinimumCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doMaximum">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Maximum
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataMaximumCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doMedian">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Median
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataMedianCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doCount">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Count
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataCountCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>

			<b-tr v-show="doStandardDeviation">
				<b-th
					:class="thTextClass + ' tabel-dinamis-footer-th'"
					:colspan="statisticsColSpan"
					:sticky-column="isFreeze"
					:style="{ left: isFreeze ? '0px' : '' }"
					>Standar Deviation
				</b-th>

				<b-td
					v-for="(item, idx) in pivotDataStandardDeviationCols"
					:key="idx"
					class="tabel-dinamis-footer-td"
				>
					{{ formatNumber(item) }}
				</b-td>
			</b-tr>
		</b-tfoot>
	</b-table-simple>
</template>

<!-- javascript section-->
<script>
//import js modules section
import utils from "../../../../../../../utils/TabelDinamisUtils";

//local registration for output component
export default {
	name: "VisualizationPivotTable",
	data() {
		return {
			backupData: [],
			tempData: [],
			colSpan: [],
			rowSpan: [],
			colTh: [],
			theadArr: [],
			tbodyArr: [],
			pivotData: [],
		};
	},
	props: [
		"choosenDataIdx",
		"choosenData",
		"choosenRowFields",
		"choosenColumnFields",
		"choosenDimensions",
		"isFinishProcessChoosenData",
		"updateIsFinishProcessChoosenData",
		"tabelDinamisSelectedDataListAlreadyCollapsed",
		"isFreeze",
		"isStripped",
		"isHighlighted",
		"isNeedReloaded",
		"updateIsNeedReloaded",
		"fontSize",
		"tableTheme",
		"doSum",
		"doAverage",
		"doMinimum",
		"doMaximum",
		"doMedian",
		"doCount",
		"doStandardDeviation",
		"doMinimumX",
		"doMaximumX",
		"doMinimumY",
		"doMaximumY",
	],
	created() {},
	destroyed() {},
	mounted() {},
	computed: {
		choosenColumnFieldsLength() {
			return this.choosenColumnFields.length;
		},
		choosenRowFieldsLength() {
			return this.choosenRowFields.length;
		},
		fontSizeClass() {
			switch (this.fontSize) {
				case "s":
					return "text-small ";
				case "m":
					return "text-medium ";
				case "l":
					return "text-large ";
				default:
					return "";
			}
		},
		thBgClass() {
			switch (this.tableTheme) {
				case "blue":
					return "td-bg-blue";
				case "teal":
					return "td-bg-teal";
				case "orange":
					return "td-bg-orange";
				case "green":
					return "td-bg-green";
				case "grey":
					return "td-bg-grey";
				case "black":
					return "td-bg-black";
				default:
					return "";
			}
		},
		thTextClass() {
			switch (this.tableTheme) {
				case "blue":
					return "td-text-blue";
				case "teal":
					return "td-text-teal";
				case "orange":
					return "td-text-orange";
				case "green":
					return "td-text-green";
				case "grey":
					return "td-text-grey";
				case "black":
					return "td-text-black";
				default:
					return "";
			}
		},
		thBorderRightClass() {
			switch (this.tableTheme) {
				case "blue":
					return "td-border-solid-thin-right-blue";
				case "teal":
					return "td-border-solid-thin-right-teal";
				case "orange":
					return "td-border-solid-thin-right-orange";
				case "green":
					return "td-border-solid-thin-right-green";
				case "grey":
					return "td-border-solid-thin-right-grey";
				case "black":
					return "td-border-solid-thin-right-black";
				default:
					return "";
			}
		},
		thBorderLeftClass() {
			switch (this.tableTheme) {
				case "blue":
					return "td-border-solid-thin-left-blue";
				case "teal":
					return "td-border-solid-thin-left-teal";
				case "orange":
					return "td-border-solid-thin-left-orange";
				case "green":
					return "td-border-solid-thin-left-green";
				case "grey":
					return "td-border-solid-thin-left-grey";
				case "black":
					return "td-border-solid-thin-left-black";
				default:
					return "";
			}
		},
		strippedTableClass() {
			return "td-stripped-table-" + this.tableTheme;
		},
		hoveredTableClass() {
			return "td-hovered-table-" + this.tableTheme;
		},
		statisticsColSpan() {
			if (this.choosenDataIdx == null || this.choosenRowFieldsLength < 1) {
				return 1;
			} else {
				return this.choosenRowFieldsLength;
			}
		},
		pivotDataSumCols() {
			let sumCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxRow) => {
					itemRow.forEach((itemCol, idxCol) => {
						if (idxRow === 0) {
							sumCols[idxCol] = 0 + itemCol === "..." ? 0 : itemCol;
						} else {
							sumCols[idxCol] += itemCol === "..." ? 0 : itemCol;
						}
					});
				});
			}
			return sumCols;
		},
		pivotDataAverageCols() {
			let averageCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				let pivotDataRowLength = this.pivotData.length;
				this.pivotDataSumCols.forEach((item, idx) => {
					averageCols[idx] =
						Math.round((item / pivotDataRowLength + Number.EPSILON) * 100) /
						100;
				});
			}
			return averageCols;
		},
		pivotDataMinimumCols() {
			let minimumCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxRow) => {
					itemRow.forEach((itemCol, idxCol) => {
						let val = itemCol === "..." ? 0 : itemCol;
						if (idxRow === 0) {
							minimumCols[idxCol] = val;
						} else {
							minimumCols[idxCol] =
								minimumCols[idxCol] > val ? val : minimumCols[idxCol];
						}
					});
				});
			}
			return minimumCols;
		},
		pivotDataMaximumCols() {
			let maximumCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxRow) => {
					itemRow.forEach((itemCol, idxCol) => {
						let val = itemCol === "..." ? 0 : itemCol;
						if (idxRow === 0) {
							maximumCols[idxCol] = val;
						} else {
							maximumCols[idxCol] =
								maximumCols[idxCol] < val ? val : maximumCols[idxCol];
						}
					});
				});
			}
			return maximumCols;
		},
		pivotDataMedianCols() {
			let medianCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxRow) => {
					itemRow.forEach((itemCol, idxCol) => {
						if (idxRow === 0) {
							medianCols[idxCol] = [itemCol];
						} else {
							medianCols[idxCol].push(itemCol);
						}
					});
				});

				medianCols.forEach((item, idx) => {
					let sorted = Array.from(item).sort((a, b) => a - b);
					let middle = Math.floor(sorted.length / 2);

					if (sorted.length % 2 === 0) {
						medianCols[idx] = (sorted[middle - 1] + sorted[middle]) / 2;
					} else {
						medianCols[idx] = sorted[middle];
					}
				});
			}

			return medianCols;
		},
		pivotDataCountCols() {
			let countCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotDataSumCols.forEach((item, idx) => {
					countCols[idx] = this.pivotData.length;
				});
			}
			return countCols;
		},
		pivotDataStandardDeviationCols() {
			let sdCols = [];
			let sumCols = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenRowFieldsLength > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				let pivotDataRowLength = this.pivotData.length;

				this.pivotData.forEach((itemRow, idxRow) => {
					itemRow.forEach((itemCol, idxCol) => {
						let val = itemCol === "..." ? 0 : itemCol;

						if (idxRow === 0) {
							sumCols[idxCol] =
								0 + Math.pow(val - this.pivotDataAverageCols[idxCol], 2);
						} else {
							sumCols[idxCol] += Math.pow(
								val - this.pivotDataAverageCols[idxCol],
								2
							);
						}
					});
				});

				sumCols.forEach((item) => {
					sdCols.push(
						Math.round(
							(Math.sqrt(item / (pivotDataRowLength - 1)) + Number.EPSILON) *
								100
						) / 100
					);
				});
			}
			return sdCols;
		},
		pivotDataSumRows() {
			let sumRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow) => {
					let sum = 0;
					itemRow.forEach((itemCol) => {
						sum += itemCol === "..." ? 0 : itemCol;
					});
					sumRows.push(sum);
				});
			}

			return sumRows;
		},
		pivotDataAverageRows() {
			let averageRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotDataSumRows.forEach((itemRow, idxItemRow) => {
					let average =
						Math.round(
							(itemRow / this.pivotData[idxItemRow].length + Number.EPSILON) *
								100
						) / 100;
					averageRows.push(average);
				});
			}
			return averageRows;
		},
		pivotDataMinimumRows() {
			let minimumRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow) => {
					let minimum;
					itemRow.forEach((itemCol, idxItemCol) => {
						if (idxItemCol === 0 || (idxItemCol !== 0 && minimum > itemCol)) {
							minimum = itemCol === "..." ? 0 : itemCol;
						}
					});
					minimumRows.push(minimum);
				});
			}
			return minimumRows;
		},
		pivotDataMaximumRows() {
			let maximumRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow) => {
					let maximum;
					itemRow.forEach((itemCol, idxItemCol) => {
						if (idxItemCol === 0 || (idxItemCol !== 0 && maximum < itemCol)) {
							maximum = itemCol === "..." ? 0 : itemCol;
						}
					});
					maximumRows.push(maximum);
				});
			}
			return maximumRows;
		},
		pivotDataMedianRows() {
			let medianRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxRow) => {
					let sorted = Array.from(itemRow).sort((a, b) => a - b);
					let middle = Math.floor(sorted.length / 2);

					if (sorted.length % 2 === 0) {
						medianRows[idxRow] = (sorted[middle - 1] + sorted[middle]) / 2;
					} else {
						medianRows[idxRow] = sorted[middle];
					}
				});
			}

			return medianRows;
		},
		pivotDataCountRows() {
			let countRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow) => {
					let count = itemRow.length;
					countRows.push(count);
				});
			}
			return countRows;
		},
		pivotDataStandardDeviationRows() {
			let sdRows = [];

			if (
				this.isFinishProcessChoosenData === true &&
				this.choosenDataIdx != null &&
				this.choosenColumnFields.length > 0 &&
				this.pivotData[0] &&
				this.pivotData[0].length
			) {
				this.pivotData.forEach((itemRow, idxItemRow) => {
					let sumCols;

					itemRow.forEach((itemCol, idxItemCol) => {
						let val = itemCol === "..." ? 0 : itemCol;

						if (idxItemCol === 0) {
							sumCols =
								0 + Math.pow(val - this.pivotDataAverageRows[idxItemRow], 2);
						} else {
							sumCols += Math.pow(
								val - this.pivotDataAverageRows[idxItemRow],
								2
							);
						}
					});

					sdRows.push(
						Math.round(
							(Math.sqrt(sumCols / (itemRow.length - 1)) + Number.EPSILON) * 100
						) / 100
					);
				});
			}
			return sdRows;
		},
	},
	watch: {
		choosenDataIdx: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal && newVal != null) {
					this.updateIsFinishProcessChoosenData(false);

					setTimeout(
						function () {
							let tempChoosenColumnFields = ["indicator", "period"];
							// let tempChoosenRowFields = ["region"];

							Object.keys(this.choosenDimensions).forEach((key2) => {
								if (
									key2.startsWith("category") &&
									this.choosenDimensions[key2].selectedItem.length > 0
								) {
									tempChoosenColumnFields.push(key2);
								}
							});

							this.theadArr = [];
							this.tbodyArr = [];
							this.tempData = [];
							this.backupData = [];
						}.bind(this),
						1000
					);

					let interval = setInterval(() => {
						if (this.tabelDinamisSelectedDataListAlreadyCollapsed === true) {
							setTimeout(
								function () {
									this.constructPivotTable();
								}.bind(this),
								1000
							);
							clearInterval(interval);
						}
					}, 500);
				}
			},
		},
		isNeedReloaded: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					if (newVal) {
						this.updateIsFinishProcessChoosenData(false);
						setTimeout(
							function () {
								this.theadArr = [];
								this.tbodyArr = [];

								this.constructPivotTable();
								this.updateIsNeedReloaded(false);
							}.bind(this),
							50
						);

						// setTimeout(
						// 	function () {
						// this.constructPivotTable(t0);
						// this.updateIsNeedReloaded(false);
						// 	}.bind(this),
						// 	2000
						// );
					}
				}
			},
		},
	},
	methods: {
		arrayLength(val) {
			return utils.arrayLength(val);
		},
		constructPivotTable() {
			this.initiliazeTempAndBackup();
			this.countColSpan();
			this.counColTh();
			this.countRowSpan();
			this.setThead();
			this.setTbody();
		},
		initiliazeTempAndBackup() {
			//set temp data by transform response.data if backupdata hasnot been set, else temp data is assigned by backup data
			if (this.backupData.length === 0) {
				this.tempData = Object.values(this.choosenData).map((item) => {
					let data = {
						value: item.value,
						indicator: item.indicator.indicatorId,
						period: item.period,
						region: item.region.itemCategoryId,
						key: item.key,
					};

					Object.entries(item).forEach(([key, value]) => {
						if (key.startsWith("itemCategory") && value.itemCategoryId > 0) {
							data["category" + key.slice(key.length - 1)] =
								value.itemCategoryId;
						}
					});

					return data;
				});

				this.backupData = JSON.parse(JSON.stringify(this.tempData));
			} else {
				this.tempData = JSON.parse(JSON.stringify(this.backupData));
			}
		},
		countColSpan() {
			this.colSpan = [];

			Object.keys(this.choosenColumnFields).forEach((key) => {
				let choosenColumnFieldsLength = this.choosenColumnFields.length;

				if (parseInt(key) === choosenColumnFieldsLength - 1) {
					this.colSpan[key] = 1;
				} else {
					let countColSpan = 1,
						widthNumber = 10;

					for (
						let idx = parseInt(key) + 1;
						idx < choosenColumnFieldsLength;
						idx++
					) {
						countColSpan *=
							this.choosenDimensions[this.choosenColumnFields[idx]].selectedItem
								.length;
					}

					if (countColSpan <= 1000) {
						this.colSpan[key] = countColSpan;
					} else {
						let leftColSpan, rightColSpan;

						if ((countColSpan - widthNumber) % 2 === 0) {
							//genap
							rightColSpan = leftColSpan = (countColSpan - widthNumber) / 2;
						} else {
							//ganjil
							leftColSpan = Math.floor((countColSpan - widthNumber) / 2);
							rightColSpan = countColSpan - 1 - leftColSpan;
						}

						leftColSpan = this.mappingLargerColSpan(leftColSpan);
						rightColSpan = this.mappingLargerColSpan(rightColSpan);

						this.colSpan[key] = {
							left: leftColSpan,
							mid: widthNumber,
							right: rightColSpan,
						};
					}
				}
			});
		},
		mappingLargerColSpan(val) {
			let temp = [];

			while (val > 1000) {
				temp.push(1000);
				val -= 1000;
			}

			if (val > 0) {
				temp.push(val);
			}

			return temp;
		},
		counColTh() {
			this.colTh = [];

			Object.keys(this.choosenColumnFields).forEach((key) => {
				if (parseInt(key) === 0) {
					this.colTh[key] = 1;
				} else {
					let countColTh = 1;
					for (let idx = 0; idx < parseInt(key); idx++) {
						countColTh *=
							this.choosenDimensions[this.choosenColumnFields[idx]].selectedItem
								.length;
					}
					this.colTh[key] = countColTh;
				}
			});
		},
		countRowSpan() {
			this.rowSpan = [];

			Object.keys(this.choosenRowFields).forEach((key) => {
				if (parseInt(key) === this.choosenRowFieldsLength - 1) {
					this.rowSpan[key] = 1;
				} else {
					let countRowSpan = 1;
					for (
						let idx = parseInt(key) + 1;
						idx < this.choosenRowFieldsLength;
						idx++
					) {
						countRowSpan *=
							this.choosenDimensions[this.choosenRowFields[idx]].selectedItem
								.length;
					}
					this.rowSpan[key] = countRowSpan;
				}
			});
		},
		setThead() {
			this.theadArr = [];

			Object.keys(this.choosenColumnFields).forEach((key) => {
				let theadRow = [];
				let theadItem = {};

				for (let a = 0; a < Object.keys(this.choosenRowFields).length; a++) {
					theadItem = {
						colspan: 1,
						text: "",
						left: a * 112,
					};

					theadRow.push(theadItem);
				}

				let selectedItem =
					this.choosenDimensions[this.choosenColumnFields[key]].selectedItem;
				for (let idx = 0; idx < this.colTh[key]; idx++) {
					Object.keys(selectedItem).forEach((key1) => {
						theadItem = {
							colspan: this.colSpan[key],
							text: selectedItem[key1].name,
						};
						theadRow.push(theadItem);
					});
				}

				this.theadArr.push(theadRow);
			});
		},
		setTbody() {
			this.tbodyArr = [];
			this.pivotData = [];

			const columnArray = [];
			this.setColumnArray(columnArray);

			const rowArray = [];
			this.setRowArray(rowArray);

			function getCombination(array, prefix) {
				prefix = prefix || "";

				if (!array.length) {
					return prefix.slice(0, -1);
				}

				var result = array[0].reduce(function (result, value) {
					return result.concat(
						getCombination(array.slice(1), prefix + value + "¸")
					);
				}, []);

				return result;
			}

			let rowArrayCombination = getCombination(rowArray);

			let columnArrayCombination = getCombination(columnArray);

			let index = [];
			let filters = [];

			//for table that only contain columns dimension
			if (rowArrayCombination.length < 1 && columnArrayCombination.length > 0) {
				let tbodyRow = [];
				let pivotDataRow = [];

				Object.keys(columnArrayCombination).forEach((key1) => {
					// filters = this.setFilters(columnArrayCombination[key1]);
					// let tbodyItem = this.validateTempData(filters);

					filters = this.setFilters2(columnArrayCombination[key1]);
					let tbodyItem = this.validateTempData2(filters);

					tbodyRow.push(tbodyItem);
					pivotDataRow.push(this.formatStringToNumber(tbodyItem.value));
				});

				this.tbodyArr.push(tbodyRow);
				this.pivotData.push(pivotDataRow);
			} else if (rowArrayCombination.length > 0) {
				Object.keys(rowArrayCombination).forEach((key1) => {
					let tbodyRow = [];
					let pivotDataRow = [];
					let rowArr = rowArrayCombination[key1].split("¸");

					rowArr.forEach((item, key) => {
						index[key] = parseInt(item.split("︴")[1].split("`")[1]);
					});

					//print row header section`
					let rowArrLength = rowArr.length;

					let countPrintedRowHeader = 0;
					rowArr.forEach((item, key) => {
						let safe = true;

						for (let i = key + 1; i < rowArrLength; i++) {
							if (index[i] !== 0) {
								safe = false;
								break;
							}
						}

						if (safe) {
							countPrintedRowHeader++;

							let tbodyItem = {
								type: "th",
								rowspan: this.rowSpan[key],
								value: item.split("︴")[1].split("`")[0],
							};
							tbodyRow.push(tbodyItem);
						}
					});

					//set for freeze table left position of row-ths
					let leftInitial = this.choosenRowFieldsLength - countPrintedRowHeader;
					tbodyRow.forEach((item) => {
						item.left = leftInitial * 112;
						leftInitial++;
					});

					//for table that only contain rows dimension
					if (columnArrayCombination.length < 1) {
						let itemRowArrayCombination = rowArr
							.map((item) => {
								return item.split("︴")[0];
							})
							.join("¸");

						// filters = this.setFilters(itemRowArrayCombination);
						// let tbodyItem = this.validateTempData(filters);

						filters = this.setFilters2(itemRowArrayCombination);
						let tbodyItem = this.validateTempData2(filters);

						tbodyRow.push(tbodyItem);
						pivotDataRow.push(this.formatStringToNumber(tbodyItem.value));
					} else if (columnArrayCombination.length > 0) {
						//for table that contain row and columns dimension
						Object.keys(columnArrayCombination).forEach((key2) => {
							let itemRowArrayCombination = rowArr
								.map((item) => {
									return item.split("︴")[0];
								})
								.join("¸");

							// filters = this.setFilters(
							// 	itemRowArrayCombination + "¸" + columnArrayCombination[key2]
							// );

							// let tbodyItem = this.validateTempData(filters);

							filters = this.setFilters2(
								itemRowArrayCombination + "¸" + columnArrayCombination[key2]
							);

							let tbodyItem = this.validateTempData2(filters);

							tbodyRow.push(tbodyItem);
							pivotDataRow.push(this.formatStringToNumber(tbodyItem.value));
						});
					}

					this.tbodyArr.push(tbodyRow);
					this.pivotData.push(pivotDataRow);
				});
			}

			this.updateIsFinishProcessChoosenData(true);
		},
		setColumnArray(columnArray) {
			return Object.values(this.choosenColumnFields).forEach((value) => {
				let dimensionItems = this.choosenDimensions[value].selectedItem.map(
					(item) => {
						return value + "—" + item.id;
					}
				);

				columnArray.push(dimensionItems);
			});
		},
		setRowArray(rowArray) {
			return Object.values(this.choosenRowFields).forEach((value) => {
				let dimensionItems = this.choosenDimensions[value].selectedItem.map(
					(item, key) => {
						return value + "—" + item.id + "︴" + item.name + "`" + key;
					}
				);

				rowArray.push(dimensionItems);
			});
		},
		setFilters(rowColumnCombination) {
			return Object.values(rowColumnCombination.split("¸")).map((value) => {
				return value.split("—");
			});
		},
		setFilters2(rowColumnCombination) {
			let filters = {};

			Object.values(rowColumnCombination.split("¸")).forEach((item) => {
				let key = item.split("—")[0],
					value = item.split("—")[1];

				filters[key] = value;
			});

			return filters;
		},
		validateTempData(filters) {
			let tbodyItem = {};

			for (let i in this.tempData) {
				let value = this.tempData[i];
				let result = "success";

				for (let i = 0; i < filters.length && result === "success"; i++) {
					if (filters[i][0] === "period") {
						if (value[filters[i][0]] !== filters[i][1]) {
							result = "fail";
						}
					} else if (value[filters[i][0]] !== parseInt(filters[i][1])) {
						result = "fail";
					}
				}

				if (result === "success") {
					tbodyItem = {
						type: "td",
						value: this.formatNumber(value.value),
					};
					// delete this.tempData[i];
					this.tempData.splice(i, 1);
					break;
				}
			}
			return tbodyItem;
		},
		validateTempData2(filters) {
			//indicator-period-region-itemCategory[1-5]
			let comparedKey =
				"" + filters["indicator"] + filters["period"] + filters["region"];

			for (let index = 1; index < 6; index++) {
				comparedKey += this.getCategoryKey(filters["category" + index]);
			}

			let foundDatum = this.tempData.find((item) => item.key === comparedKey);

			return {
				type: "td",
				value: this.formatNumber(foundDatum.value),
			};
		},
		getCategoryKey(val) {
			return val == undefined ? "0" : val;
		},
		formatNumber(str) {
			if (str == undefined || str == null) {
				return "-";
			} else {
				let xy = this.pointWithCommaForDecimal(str.toString());
				return this.numberWithPoint(xy);
			}
		},
		numberWithPoint(str) {
			if (str !== "...") {
				let parts = str.toString().split(",");
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
				return parts.join(",");
			} else {
				return str;
			}
		},
		pointWithCommaForDecimal(str) {
			if (str !== "...") {
				return str.replace(/\./g, ",");
			} else {
				return str;
			}
		},
		formatStringToNumber(str) {
			return Number(
				this.replaceCommadDecimalWithPoint(this.replaceAllPointInString(str))
			);
		},
		replaceAllPointInString(str) {
			return str.replace(/\./g, "");
		},
		replaceCommadDecimalWithPoint(str) {
			return str.replace(/,/g, ".");
		},
		checkTdAsMinimumX(val, idx) {
			let output =
				(val === "..." ? 0 : this.formatStringToNumber(val)) ===
					this.pivotDataMinimumRows[idx] && this.doMinimumX
					? " tabel-dinamis-minimum-x-td "
					: "";
			return output;
		},
		checkTdAsMaximumX(val, idx) {
			let output =
				(val === "..." ? 0 : this.formatStringToNumber(val)) ===
					this.pivotDataMaximumRows[idx] && this.doMaximumX
					? " tabel-dinamis-maximum-x-td "
					: "";
			return output;
		},
		checkTdAsMinimumY(val, idx) {
			let output =
				(val === "..." ? 0 : this.formatStringToNumber(val)) ===
					this.pivotDataMinimumCols[idx - 1] && this.doMinimumY
					? " tabel-dinamis-minimum-y-td "
					: "";
			return output;
		},
		checkTdAsMaximumY(val, idx) {
			let output =
				(val === "..." ? 0 : this.formatStringToNumber(val)) ===
					this.pivotDataMaximumCols[idx - 1] && this.doMaximumY
					? " tabel-dinamis-maximum-y-td "
					: "";
			return output;
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";

#tabel-dinamis-pivot-table.text-small > thead > tr,
#tabel-dinamis-pivot-table.text-small > tbody > tr,
#tabel-dinamis-pivot-table.text-small > tfoot > tr {
	font-size: 9pt !important;
}
#tabel-dinamis-pivot-table.text-medium > thead > tr,
#tabel-dinamis-pivot-table.text-medium > tbody > tr,
#tabel-dinamis-pivot-table.text-medium > tfoot > tr {
	font-size: 10pt !important;
}
#tabel-dinamis-pivot-table.text-large > thead > tr,
#tabel-dinamis-pivot-table.text-large > tbody > tr,
#tabel-dinamis-pivot-table.text-large > tfoo > tr {
	font-size: 12pt !important;
}

/* #tabel-dinamis-pivot-table.table-striped tbody tr:nth-of-type(2n) {
	background-color: $light-blue;
} */

#tabel-dinamis-pivot-table.table-striped tbody tr:nth-of-type(2n + 1) {
	background-color: white;
}

/* #tabel-dinamis-pivot-table.table-hover tbody tr:hover {
	background-color: $mid-blue;
} */

#tabel-dinamis-pivot-table .tabel-dinamis-th {
	min-width: 7rem;
	max-width: 11rem;
	color: white !important;
	vertical-align: middle !important;
	text-align: center;
	font-weight: bold;
}

#tabel-dinamis-pivot-table .tabel-dinamis-footer-th,
#tabel-dinamis-pivot-table .tabel-dinamis-columns-summary-th {
	min-width: 7rem;
	max-width: 11rem;
	vertical-align: middle !important;
	text-align: center;
	font-weight: bold;
}

#tabel-dinamis-pivot-table .tabel-dinamis-td {
	text-align: right !important;
	vertical-align: middle !important;
	padding-right: 0.75rem !important;
}

#tabel-dinamis-pivot-table .tabel-dinamis-footer-td,
#tabel-dinamis-pivot-table .tabel-dinamis-columns-summary-td {
	text-align: right !important;
	vertical-align: middle !important;
	padding-right: 0.75rem !important;
	font-weight: bold;
}

.b-table-sticky-header {
	max-height: 400px !important;
}

.tabel-dinamis-minimum-x-td {
	background-color: $light-red;
}
.tabel-dinamis-maximum-x-td {
	background-color: $light-purple;
}

.tabel-dinamis-minimum-y-td {
	background-color: $mid-red;
}
.tabel-dinamis-maximum-y-td {
	background-color: $mid-purple;
}
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 21-09-2022 -->
